import { TYPE_PERTURBATEUR } from '../model';

export default factory;

function factory() {
  return (value) => {
    switch (value) {
      case TYPE_PERTURBATEUR.CONSTRUCTION:
        return 'Construction';
      case TYPE_PERTURBATEUR.EOLIENNE:
        return 'Éolienne';
      default:
        return '';
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/prtv/filters/type-perturbateur.filter.js